export default ['$window', 'userService', function ($window, userService) {
  this.currentLocation = encodeURIComponent($window.location.href);
  this.refillBalance = () => {
    userService.pollTillBalanceUpdate();
  };
}];
